<template>
  <span
    class="gr-file-chip"
    :class="{
      'gr-file-chip-clickable': clickable && !invalid,
      'gr-file-chip-invalid': invalid,
    }"
    :title="filename"
    @click.stop="handleClick"
  >
    <span class="gr-file-chip-name">
      <span class="gr-file-chip-basename">{{ baseName }}</span
      ><span class="gr-file-chip-ext">{{ ext }}</span>
    </span>
    <button
      v-if="showDelete"
      type="button"
      class="gr-file-chip-remove"
      @click.stop="$emit('remove')"
    >
      ✕
    </button>
  </span>
</template>

<script>
export default {
  name: "GrFileChip",
  props: {
    filename: {
      type: String,
      required: true,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    baseName() {
      const dot = this.filename.lastIndexOf(".");
      return dot > 0 ? this.filename.slice(0, dot) : this.filename;
    },
    ext() {
      const dot = this.filename.lastIndexOf(".");
      return dot > 0 ? this.filename.slice(dot) : "";
    },
  },
  methods: {
    handleClick() {
      if (!this.clickable || this.invalid) return;
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.gr-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border: 1px solid #ced4da;
  border-radius: 999px;
  background: #fff;
  font-size: 13px;
  color: #212529;
  cursor: default;
  max-width: 280px;
  min-width: 0;
}

.gr-file-chip-name {
  flex: 1;
  min-width: 0;
  display: flex;
}

.gr-file-chip-basename {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.gr-file-chip-ext {
  flex-shrink: 0;
  white-space: nowrap;
}

.gr-file-chip-clickable {
  cursor: pointer;
  transition: background 0.15s;
}

.gr-file-chip-clickable:hover {
  background: #f0f6ff;
  border-color: #0d6efd;
  color: #0d6efd;
}

.gr-file-chip-remove {
  background: transparent;
  border: none;
  padding: 0;
  color: #495057;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  flex-shrink: 0;
}

.gr-file-chip-remove:hover {
  color: #dc3545;
}

.gr-file-chip-invalid {
  border-color: #dc3545 !important;
  background: #fff5f5;
  color: #dc3545;
  cursor: default;
}
</style>
